import React from 'react';

import { usePriceQuery } from 'hooks/payments';

import Button from 'components/button';
import { ReactComponent as Plus } from 'svg/plus.svg';
import { ReactComponent as Connection } from 'svg/connection.svg';

import './style.css';

const CallToAction = () => {
  const size = 'm';
  const { data } = usePriceQuery();
  const { currency, unit_amount: price } = data || {};
  return (
    <section className="call-to-action">
      <h2 className="call-to-action-message" id="video-end-circuit">
        Have you ever wondered.
        <br />
        What would&apos;ve happened if you moved past
        <br />
        whats stopping you?
        <br />
      </h2>

      <div className="call-to-action-actions">
        <Button size={size} href="/about" id="call-start-02-circuit">
          Learn More
        </Button>
        <div className="find-out">
          <Button size={size} href="/signup" id="call-end-02-circuit">
            Find Out Now!
          </Button>
          {price ? (
            <span className="price">
              For ${price / 100} {currency.toUpperCase()}
            </span>
          ) : null}
        </div>
        <div id="call-end-03-circuit" className="call-end-03-circuit target" />
      </div>
      <Connection id="call-start-circuit" className="call-start-circuit" />
      <Plus id="call-end-circuit" className="call-end-circuit" />
    </section>
  );
};

export default CallToAction;
